import yx1_earphones_mobile from '../components/assets/category-earphones/mobile/image-yx1-earphones.jpg';
import yx1_earphones_tablet from '../components/assets/category-earphones/tablet/image-yx1-earphones.jpg';
import yx1_earphones_desktop from '../components/assets/category-earphones/desktop/image-yx1-earphones.jpg';

const data = [
  {
    id: 1,
    img: {
      mobile: yx1_earphones_mobile,
      tablet: yx1_earphones_tablet,
      desktop: yx1_earphones_desktop,
    },
    name: 'yx1 wireless earphones',
    text: 'Tailor your listening experience with bespoke dynamic drivers from the new YX1 Wireless Earphones. Enjoy incredible high-fidelity sound even in noisy environments with its active noise cancellation feature.Tailor your listening experience with bespoke dynamic drivers from the new YX1 Wireless Earphones. Enjoy incredible high-fidelity sound even in noisy environments with its active noise cancellation feature.',
    new_label: true,
  },
];
export default data;